import React, { useState } from 'react';
import { CandlestickChart, Search } from 'lucide-react';
import { DashboardLayout } from '../../app/layouts/DashboardLayout';
import { MEMBER_NAV } from '../../constants/nav';
import { TradingViewChart } from '../../components/chart/TradingViewChart';

const STORAGE_KEY = 'member_chart_symbol';

const QUICK_SYMBOLS = [
  { label: 'Gold', symbol: 'OANDA:XAUUSD' },
  { label: 'EURUSD', symbol: 'OANDA:EURUSD' },
  { label: 'GBPUSD', symbol: 'OANDA:GBPUSD' },
  { label: 'USDJPY', symbol: 'OANDA:USDJPY' },
  { label: 'BTCUSD', symbol: 'BINANCE:BTCUSDT' },
  { label: 'ETHUSD', symbol: 'BINANCE:ETHUSDT' },
  { label: 'Nasdaq', symbol: 'OANDA:NAS100USD' },
  { label: 'US30', symbol: 'OANDA:US30USD' },
  { label: 'Oil (WTI)', symbol: 'TVC:USOIL' },
];

const DEFAULT_SYMBOL = QUICK_SYMBOLS[0].symbol;

export default function MemberChartPage() {
  const [symbol, setSymbol] = useState(() => localStorage.getItem(STORAGE_KEY) || DEFAULT_SYMBOL);
  const [query, setQuery] = useState('');

  const pick = (s: string) => {
    setSymbol(s);
    localStorage.setItem(STORAGE_KEY, s);
  };

  const search = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim().toUpperCase();
    if (!q) return;
    pick(q);
    setQuery('');
  };

  return (
    <DashboardLayout navItems={MEMBER_NAV} title="Chart Live">
      <div data-testid="member-chart-page">
        <div className="mb-5 flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center shrink-0">
            <CandlestickChart className="w-5 h-5 text-cyan-400" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-cyan-400">TradingView</p>
            <h2 className="text-2xl sm:text-3xl tracking-tight font-medium text-white">Chart Live</h2>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-center gap-3 mb-4">
          <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 lg:flex-wrap lg:overflow-visible">
            {QUICK_SYMBOLS.map((s) => (
              <button
                key={s.symbol}
                data-testid={`chart-symbol-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                onClick={() => pick(s.symbol)}
                className={`shrink-0 px-3.5 py-1.5 rounded-full text-xs border transition-colors ${
                  symbol === s.symbol
                    ? 'bg-cyan-400 text-[#050914] border-cyan-400 font-medium'
                    : 'bg-white/5 text-white/70 border-white/10 hover:text-white hover:border-cyan-400/40'
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
          <form onSubmit={search} className="relative lg:ml-auto lg:w-64 shrink-0">
            <Search className="w-4 h-4 text-white/30 absolute left-3 top-1/2 -translate-y-1/2" strokeWidth={1.5} />
            <input
              data-testid="chart-symbol-search-input"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Cari simbol, mis. AAPL"
              className="w-full bg-[#050914] border border-white/10 rounded-lg pl-9 pr-3 py-2 text-white placeholder:text-white/30 focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400/50 outline-none transition-colors text-sm"
            />
          </form>
        </div>

        <TradingViewChart symbol={symbol} height="calc(100vh - 290px)" />

        <p className="text-[11px] text-white/35 mt-3 leading-relaxed">
          Data chart disediakan oleh{' '}
          <a href="https://www.tradingview.com" target="_blank" rel="noreferrer" className="text-cyan-400/70 hover:text-cyan-400">
            TradingView
          </a>
          . Tampilan ini bersifat informasi dan bukan rekomendasi beli/jual. Layout, indikator, dan garis gambar tidak tersimpan permanen pada widget gratis.
        </p>
      </div>
    </DashboardLayout>
  );
}
